import React from 'react'
import { Table } from 'antd'
import { TableRowEditButton } from '../../components/AppButton'
import FormattedDate from '../../components/FormattedDate'

class ItemListTable extends React.Component {
  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
        width: 10,
        sorter: true,
      }, {
        title: 'Order',
        dataIndex: 'order',
        key: 'order',
        sorter: true,
      }, {
        title: 'Practice Area',
        dataIndex: 'practice_areas_id',
        key: 'practice_areas_id',
        render: id => this.props.pa.filter(pa => pa.id === id)[0].name,
      }, {
        title: 'Created At',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        render: text => <FormattedDate text={text} />,
      }, {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 100,
        render: (text, record) => (
          <span>
            <TableRowEditButton to={`${this.props.editPath}/${record.id}`} /><br />
            <TableRowEditButton name='Cases' to={`${this.props.browsePath}/${record.id}/cases`} />
          </span>
        ),
      },
    ]
    return (
      <Table
        rowKey={record => `item-row-${record.id}`}
        columns={columns}
        size='small'
        scroll={{ x: 900 }}
        {...this.props}
      />
    )
  }
}

export default ItemListTable
